import FeatureType from './FeatureType'

const Feature: { [key in FeatureType]: { text: string } } = {
  [FeatureType.CheerfulAndClean]: { text: '元気で清潔感があると言われます' },
  [FeatureType.HasInsuranceOrRealEstate]: { text: '不動産をやってます' },
  [FeatureType.ManyFemaleGuests]: { text: '女性のお客様が多いです2' },
  [FeatureType.HighlyEducated]: { text: '学歴があり数字に強いです' },
  [FeatureType.isManager]: { text: '実績があり役職についてます' },
  [FeatureType.CanSimulation]: { text: '将来のシュミレーション出せます' },
  [FeatureType.HasManyPattern]: { text: '何パターンもご提案できます' },
  [FeatureType.GoodAfterFollow]: { text: 'アフターフォローにも自信あり' },
  [FeatureType.EasyWord]: { text: '難しい言葉使いません' },
  [FeatureType.FriendlyTone]: { text: '口調が優しいと言われます' }
}

export default Feature
